import React from 'react';
import { connect } from 'react-redux';
import action from '@flux/action';

const Hint = ({ popCanNotFindMemberModal }) => (
  <div className="a-can-not-find-member-hint">
    <p>
      Looking to add a PwC Team Member and can&apos;t find them? Report an issue
      <span onClick={popCanNotFindMemberModal}>here</span>
      and provide the user&apos;s Name, GUID, and email address.
    </p>
  </div>
);

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  popCanNotFindMemberModal: () => {
    dispatch(
      action.popReportIssueModal({
        connectedPage: 'Create Project',
        category: "I can't add users",
      }),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Hint);
